module.exports = "<div class=\"ibox-tools\" dropdown>\n  <a class=\"collapse-link\" (click)=\"collapse($event)\">\n    <i class=\"fa fa-chevron-up\"></i>\n  </a>\n  <a dropdownToggle>\n    <i class=\"fa fa-wrench\"></i>\n  </a>\n  <ul class=\"dropdown-menu dropdown-user\" *dropdownMenu>\n    <li><a href=\"#\">Config option 1</a>\n    </li>\n    <li><a href=\"#\">Config option 2</a>\n    </li>\n  </ul>\n  <a class=\"close-link\" (click)=\"close($event)\">\n    <i class=\"fa fa-times\"></i>\n  </a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/iboxtools/iboxtools.template.html
// module id = ./src/app/components/common/iboxtools/iboxtools.template.html
// module chunks = main